<template>
  <div class="m-codeString">
    <span
      v-for="(text, key) in textShow"
      :key="key"
      :class="{'is-code': isCode(text)}"
      @click="handleClick(text)"
      v-html="text"
    />
  </div>
</template>

<script>
export default {
  name: 'BookingCode',
  props: {
    data: {
      type: String,
      default: ''
    },
    code: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    textShow() {
      let { data, code } = this
      data = data.replace(/</g, '&lt;').replace(/>/g, '&gt;')
      const codeList = Array.from(new Set(code))
      let _show = [data.replace(/\n/g, '<br/>')]

      if (codeList && codeList.length) {
        codeList.forEach((code) => {
          _show = _show.map((str) => {
            if (str.indexOf(code) !== -1) {
              let strArr = str.split(code)
              strArr = strArr.map((strItem, itemKey) => {
                return itemKey !== strArr.length - 1 ? [strItem, code] : strItem
              })
              strArr = [].concat(...strArr)
              return strArr
            } else {
              return str
            }
          })
          _show = [].concat(..._show)
        })
      }
      return _show
    }
  },
  methods: {
    isCode(text) {
      return this.code && this.code.length && this.code.indexOf(text) !== -1
    },
    handleClick(text) {
      if (this.isCode(text)) this.$emit('codeClick', text)
    }
  }
}
</script>
<style lang="less">
@import url("~wap/common/style/variable.less");

.m-codeString {
  .is-code {
    display: inline-block;
    color: @primary;
    text-decoration: underline;
  }
}
</style>
